import axios from "src/utils/axios";
import { dataLocalStorage, getLocalStorage } from "src/helper/publicFunction";

// The Undo in a "Deleted" message (CMS review georges-06, karim-23): the
// deletes the Activity log can restore, by the address they are sent to and
// the field that carries their ids. A delete elsewhere shows no Undo.
export const DELETE_ROUTES = {
  "documents/delete": { table: "documents", ids: "idsdocuments" },
  "questionnaires/delete": { table: "info_list", ids: "idsquestionnaires" },
  "questions_category/delete": { table: "info_type", ids: "idsquestions_category" },
  "visaType/delete": { table: "visa_type", ids: "idsvisatype" },
  "nationality/delete": { table: "nationality", ids: "idsnationality" },
  "country/delete": { table: "country", ids: "idscountry" },
  "group/delete": { table: "country_group", ids: "idgroups" },
  "price/delete": { table: "visa_type_price", ids: "idsprice" },
  "faq/delete": { table: "country_faq", ids: "idsfaqs" },
  "clients/delete": { table: "client", ids: "idsclients" },
  "admins/delete": { table: "admins", ids: "idsAdmin" },
  "country_management_details/natonality/delete": { table: "country_nationality", ids: "idcountry_nationality" },
};

const RESTORE_ROUTE = "admin_logs/restore";

// The ids a delete request carried: an array, one id, a JSON list or a form.
export function idsIn(data, key) {
  const raw = typeof FormData !== "undefined" && data instanceof FormData ? data.getAll(key) : data?.[key];
  let list = raw;
  if (typeof raw === "string") {
    try {
      list = JSON.parse(raw);
    } catch {
      list = raw.split(",");
    }
  }
  return (Array.isArray(list) ? list : [list]).map(Number).filter((n) => Number.isInteger(n) && n > 0);
}

/** { table, ids } for a delete the Activity log can restore, else null. */
export function undoFor(route, data) {
  const entry = DELETE_ROUTES[String(route || "").replace(/^\/+/, "")];
  if (!entry) return null;
  const ids = idsIn(data, entry.ids);
  return ids.length ? { table: entry.table, ids } : null;
}

// Restoring takes the Activity log's edit right, as its own Undo does.
export function canUndo() {
  const privileges = getLocalStorage(dataLocalStorage.privileges) || {};
  return privileges?.["12"]?.access_edit == 1; // eslint-disable-line eqeqeq
}

/** Brings the records back. Resolves to the number restored; throws with the server's words. */
export async function restoreDeleted({ table, ids }) {
  const token = getLocalStorage(dataLocalStorage.userinfo)?.token ?? "";
  try {
    const res = await axios({ method: "post", url: RESTORE_ROUTE, data: { table, ids }, headers: { Authorization: `Bearer ${token}` } });
    return res?.data?.data?.restored ?? 0;
  } catch (err) {
    const message = err?.response?.data?.message;
    throw new Error(typeof message === "string" && message.length < 200 ? message : "Nothing was restored. Try the Activity log.");
  }
}
